import { render, staticRenderFns } from "./RAreas.vue?vue&type=template&id=4da8c619"
import script from "./RAreas.vue?vue&type=script&lang=js"
export * from "./RAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports